import { SvgIcon } from 'ui/icons/SvgIcon';

export const IterableSms = ({ height = 48, width = 48 }) => (
  <SvgIcon width={width} height={height} viewBox="0 0 64 64">
    <g clipPath="url(#iterable_sms_svg_bg)">
      <path
        opacity="0.25"
        d="M45.0678 27.713L27.9526 44.8281L36.5746 53.4501L53.6897 36.3349L45.0678 27.713Z"
        fill="#59C1A7"
      />
      <path
        opacity="0.25"
        d="M36.4603 10.4562L27.8384 19.0781L44.9535 36.1933L53.5755 27.5714L36.4603 10.4562Z"
        fill="#34C3F2"
      />
      <path
        opacity="0.15"
        d="M19.0804 27.7218L10.4585 36.3438L27.5737 53.4589L36.1956 44.837L19.0804 27.7218Z"
        fill="#EF3D55"
      />
      <path
        opacity="0.15"
        d="M27.9824 10.0513L10.8672 27.1665L19.4891 35.7884L36.6043 18.6733L27.9824 10.0513Z"
        fill="#6A266D"
      />
      <path
        d="M32.0455 20.779C35.4377 20.779 38.1877 18.029 38.1877 14.6368C38.1877 11.2446 35.4377 8.49463 32.0455 8.49463C28.6533 8.49463 25.9033 11.2446 25.9033 14.6368C25.9033 18.029 28.6533 20.779 32.0455 20.779Z"
        fill="#6A266D"
      />
      <path
        d="M49.3805 38.1906C52.7727 38.1906 55.5226 35.4407 55.5226 32.0484C55.5226 28.6562 52.7727 25.9062 49.3805 25.9062C45.9882 25.9062 43.2383 28.6562 43.2383 32.0484C43.2383 35.4407 45.9882 38.1906 49.3805 38.1906Z"
        fill="#34C3F2"
      />
      <path
        d="M32.0455 55.5236C35.4377 55.5236 38.1877 52.7737 38.1877 49.3814C38.1877 45.9892 35.4377 43.2393 32.0455 43.2393C28.6533 43.2393 25.9033 45.9892 25.9033 49.3814C25.9033 52.7737 28.6533 55.5236 32.0455 55.5236Z"
        fill="#59C1A7"
      />
      <path
        d="M14.711 38.1227C18.1033 38.1227 20.8532 35.3728 20.8532 31.9806C20.8532 28.5883 18.1033 25.8384 14.711 25.8384C11.3188 25.8384 8.56885 28.5883 8.56885 31.9806C8.56885 35.3728 11.3188 38.1227 14.711 38.1227Z"
        fill="#EF3D55"
      />
    </g>
    <path
      d="M51.7071 60.2929L54 58H48L50.2929 60.2929C50.6834 60.6834 51.3166 60.6834 51.7071 60.2929Z"
      fill="#79347F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44 43C42.3431 43 41 44.3431 41 46V55C41 56.6569 42.3431 58 44 58H58C59.6569 58 61 56.6569 61 55V46C61 44.3431 59.6569 43 58 43H44ZM46 52C46.8284 52 47.5 51.3284 47.5 50.5C47.5 49.6716 46.8284 49 46 49C45.1716 49 44.5 49.6716 44.5 50.5C44.5 51.3284 45.1716 52 46 52ZM51 52C51.8284 52 52.5 51.3284 52.5 50.5C52.5 49.6716 51.8284 49 51 49C50.1716 49 49.5 49.6716 49.5 50.5C49.5 51.3284 50.1716 52 51 52ZM57.5 50.5C57.5 51.3284 56.8284 52 56 52C55.1716 52 54.5 51.3284 54.5 50.5C54.5 49.6716 55.1716 49 56 49C56.8284 49 57.5 49.6716 57.5 50.5Z"
      fill="#79347F"
    />
    <defs>
      <clipPath id="iterable_sms_svg_bg">
        <rect width="48" height="48" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </SvgIcon>
);
